import { HiddenAxios } from "@/functions/axios-functions";
import { SettingsContext } from "@/utilities/settings-context";
import { inject, onMounted, provide, reactive, ref } from "@vue/composition-api";


type FeatureFlagName =
    | 'userTeamtailorServiceConnection'
    | 'userTeamtailorXmlServiceConnection'
    | 'contactSalesButton'
    | 'pontyServiceConnection';

export type FeatureFlags = Record<FeatureFlagName, boolean>;

const stateSymbol = Symbol('feature-flags-service');

const createService = () => {
    const flags = reactive<FeatureFlags>({
        'userTeamtailorServiceConnection': false,
        'userTeamtailorXmlServiceConnection': false,
        'contactSalesButton': false,
    'pontyServiceConnection': false,
    });

    onMounted(async () => {
        try {
            const response = await HiddenAxios.get<FeatureFlags>(SettingsContext.getApiUrl('enabledFeatures'));
            if(!response.data) {
                console.error('No feature flags returned');
                return;
            }
            
            Object.entries(response.data)
            .forEach(([k, v]) => {
                flags[k as FeatureFlagName] = v ?? flags[k as FeatureFlagName];
            });
        }
        catch (e) {
            console.error('Failed to fetch feature flags', e);
        }
    });

    return flags as Readonly<FeatureFlags>;
};

export function useFeatureFlags() {
    const service = inject<FeatureFlags>(stateSymbol);

    if(!service) throw new Error("Feature flags not provided");

    return service;
}

export function provideFeatureFlags() {
    return provide(
        stateSymbol,
        createService()
    );
}
